<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
    custom-export-url="/show-people/export/"
    has-availabilities
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.person"
            :preselect="editedItem.person__name"
            lazy
            :error-messages="error.person"
            :model="personModel"
            item-text="name"
            item-value="id"
            label="Persona"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.instruments"
            :error-messages="error.instruments"
            :model="instrumentModel"
            item-text="name"
            item-value="id"
            chips
            label="Strumenti"
            multiple
          ></autocomplete>
        </v-col>
        <v-textarea
          v-model="editedItem.availability_preferences"
          :error-messages="error.availability_preferences"
          label="Preferenze disponibilità"
        ></v-textarea>
        <v-textarea
          v-model="editedItem.internal_notes"
          :error-messages="error.internal_notes"
          label="Note interne"
        ></v-textarea>
      </v-row>
      <p v-if-superuser>
        <span v-if="get(editedItem, 'person__telephone_number')">
          <b>Cellulare:</b>
          {{ editedItem.person__telephone_number }} -
        </span>
        <span v-if="get(editedItem, 'person__email')">
          <b>Email:</b>
          {{ editedItem.person__email }} -
        </span>
        <span v-if="get(editedItem, 'person__instruments', []).length">
          <b>Strumenti:</b>
          {{ editedItem.person__instruments }}
        </span>
      </p>
      <v-row>
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="editedItem.accepted_terms_performance"
            disabled
            label="Accettato i termini prestazione artistica"
            :messages="[
              dateIfAccepted(
                editedItem.accepted_terms_performance,
                editedItem.accepted_terms_performance_date
              ),
            ]"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="editedItem.accepted_terms_hospitality"
            disabled
            label="Accettato i termini accoglienza"
            :messages="[
              dateIfAccepted(
                editedItem.accepted_terms_hospitality,
                editedItem.accepted_terms_hospitality_date
              ),
            ]"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="editedItem.accepted_terms_privacy"
            disabled
            label="Accettato i termini privacy"
            :messages="[
              dateIfAccepted(
                editedItem.accepted_terms_privacy,
                editedItem.accepted_terms_privacy_date
              ),
            ]"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="3">
          <v-checkbox
            v-model="editedItem.accepted_terms_media"
            disabled
            label="Accettato i termini foto/video"
            :messages="[
              dateIfAccepted(
                editedItem.accepted_terms_media,
                editedItem.accepted_terms_media_date
              ),
            ]"
          ></v-checkbox>
        </v-col>
      </v-row>
      <ul v-if="editedItem" v-if-superuser></ul>
      <ul v-if="editedItem.warnings && editedItem.warnings.length > 0">
        <li
          v-for="warning in editedItem.warnings"
          :key="warning"
          class="red--text"
        >
          <template v-if="warning.type == 'outside_person_availability_range'">
            L'evento associato {{ warning.event_name }} è all'infuori del range
            di disponibilità
          </template>
          <template v-else-if="warning.type == 'person_events_overlap'">
            L'evento associato {{ warning.event_name }} si sovrappone ad altri
            eventi
          </template>
          <template v-if="warning.type == 'transport_outside_person_availability_range'">
            Il trasporto è all'infuori del range
            di disponibilità
          </template>
          <template v-else-if="warning.type == 'person_transports_overlap'">
            Il trasport associato si sovrappone ad altri
            eventi
          </template>
        </li>
      </ul>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>
    <template v-slot:item.instruments="{ item }">
      {{ item.instruments.length }}
    </template>
    <template v-slot:item.person__is_verified="{ item }">
      <v-simple-checkbox
        v-model="item.person__is_verified"
        disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.has_accepted_all_terms="{ item }">
      <v-simple-checkbox
        v-model="item.has_accepted_all_terms"
        disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.export="{ item }">
      <router-link
        :to="{
          name: 'ExportPerson',
          params: { id: modelFk.show, personId: item.person, showPersonId: item.id },
        }"
      >
        Esporta
      </router-link>
    </template>
    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import { uniq } from "@/lodash"

import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Persona", value: "person__name" },
        { text: "Stato", value: "status" },
        { text: "Strumenti", value: "instruments" },
        { text: "Verif.?", value: "person__is_verified" },
        { text: "Privacy", value: "has_accepted_all_terms" },
        { text: "Alert", value: "warnings" },
        { text: "Esporta", value: "export" },
      ],
      model: models.ShowPerson,
      personModel: models.Person,
      instrumentModel: models.Instrument,
      statuses,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
    filters() {
      return [
        {
          name: "person__category",
          model: models.PersonCategory,
          text: "name",
        },
        {
          name: "instruments",
          model: models.Instrument,
          text: "name",
        },
        {
          name: "person__citizenship_code",
          label: "Cittadinanza",
          values: (items) =>
            uniq(items.map((i) => i.person__citizenship_code).filter((i) => i)),
        },
        // {
        //   name: "instruments",
        //   model: models.Instrument,
        //   text: "name",
        // },
      ]
    },
  },
  methods: {
    defaultItem: () => ({
      person: null,
      instruments: [],
      availabilities: [],
    }),
    dateIfAccepted(acceptedTerms, date) {
      return acceptedTerms
        ? this.$formatDate(this.$parseDate(date), "d MMMM y")
        : ""
    },
  },
}
</script>
